import { isRetryableQueryError, shouldRetryQuery } from '../../../utils/queryRetry';

export const PENDING_BATCH_RETRY_DELAY = 5000;
export const MAX_PENDING_BATCH_RETRIES = 120;

export const isPendingBatchBusy = (error) =>
  Number(error?.status) === 409 && error?.code === 'BATCH_ROUTING_BUSY' &&
  isRetryableQueryError(error);

// Keep one policy per query owner. A new fetch (including an explicit retry)
// starts at failureCount 0. BUSY is confirmed server progress, so it has its own
// bounded budget; it must not exhaust or extend the normal network retry budget.
export const createPendingBatchRetryPolicy = () => {
  let busyFailures = 0;
  let transientFailures = 0;
  const resetForNewFetch = (failureCount) => {
    if (failureCount === 0) {
      busyFailures = 0;
      transientFailures = 0;
    }
  };
  return {
    retry: (failureCount, error) => {
      resetForNewFetch(failureCount);
      if (isPendingBatchBusy(error)) return busyFailures++ < MAX_PENDING_BATCH_RETRIES;
      return shouldRetryQuery(transientFailures++, error);
    },
    retryDelay: (failureCount, error) => {
      resetForNewFetch(failureCount);
      // React Query calculates the delay before asking retry for this failure.
      return isPendingBatchBusy(error) ? PENDING_BATCH_RETRY_DELAY :
        Math.min(1000 * 2 ** transientFailures, 30000);
    },
  };
};
